(function ($) {
  Drupal.behaviors.sppcrossSellsV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $modules = $('.spp-cross-sells-v1', context);
      var $grids = $('.js-product-grid', $modules);
      var $carousels = $('.js-product-brief-carousel-items', $grids);
      var isRTL = site.direction.isRTL && Drupal?.settings?.forceSlickRTL;

      $carousels.each(function () {
        var $this = $(this);
        var $arrowsDiv = $this.parent().find('.carousel-controls');
        var slides_to_show = JSON.parse($this.closest('.js-product-grid').attr('data-grid-items-per-row'));
        var settings = {
          rtl: isRTL,
          appendArrows: $arrowsDiv,
          infinite: true,
          slidesToShow: slides_to_show.large,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                dots: false,
                slidesToShow: slides_to_show.medium,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 769,
              settings: {
                arrows: true,
                dots: false,
                slidesToShow: slides_to_show.small,
                slidesToScroll: 1
              }
            }
          ]
        };

        // Init this carousel with our settings
        $this.slick(settings);
      });

      $(window).resize(_.debounce(function () {
        var isiPad = navigator.userAgent.match(/iPad/i) != null;
        var $slides = $carousels.find('.slick-slide');

        if (isiPad) {
          $slides.each(function () {
            $(this).height('auto');
          });
        }
      }, 200));
    },
    attached: false
  };
})(jQuery);
